/**
 * @module network/postMessage
 */

/**
 * Executes a PostMessage to the current parent.
 * @param {*} message The message to be sent.
 */
export function postMessage(message, parentFrame = window.parent) {
    if (window.self !== window.top) {
        parentFrame.postMessage(JSON.stringify(message), '*');
    }
}

/**
 * Executes a PostMessage to the topmost frame.
 * @param {*} message The message to be sent.
 */
export function postMessageToTopmostFrame(message, parentFrame = window.parent) {
    postMessage(message);

    if (parentFrame !== parentFrame.top) {
        postMessageToTopmostFrame(message, parentFrame.parent);
    }
}

/**
 * Attach to a post message
 * @param {*} window Window instance to which the listener will be attached
 * @param {*} messageName Name of message(event)
 * @param {*} handler Callback
 */
export function attachPostMessageEventListener(window, messageName, handler) {
    window.addEventListener('message', (event) => {
        if (event.data) {
            try {
                const message = JSON.parse(event.data);

                if (message && message.messageName && message.messageName === messageName) {
                    handler(message);
                }
            } catch (e) {
                // ignore calls with incorrect json
            }
        }
    });
}
